import React from "react";

const Select = ({ options, value, onChange, className, dataTestId }) => {
  return (
    <select
      className={className}
      value={value}
      onChange={onChange}
      data-testid={dataTestId}
    >
      {options.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  );
};

export default Select;
